// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import { ON_MY_MATCH_TOGGLE_TRANSITION_DURATION } from '../../../constants/ui/mymatch';
import theme from '../../../styled-components/dark';

const SvgElement = styled.svg``;

const SelectedPath = styled.path`
  fill: var(--FavoriteButton-selectedFill, ${theme.FavoriteButton.selected.color});
`;

const UnselectedPath = styled.path`
  transition-property: fill, stroke;
  transition-duration: ${ON_MY_MATCH_TOGGLE_TRANSITION_DURATION}ms;
  transition-timing-function: ease-in-out;

  fill: var(--FavoriteButton-defaultFill, ${theme.FavoriteButton.normal.color});
  stroke: var(--FavoriteButton-defaultStroke, ${theme.FavoriteButton.normal.stroke});
`;

type StarSvgAsComponentProps = {
  isActive?: boolean;
  className?: string;
};

const StarSvgAsComponent = ({ className = '', isActive = false }: StarSvgAsComponentProps) => {
  const title = useMemo(() => (isActive ? 'star' : 'star-unselect'), [isActive]);

  return (
    <SvgElement
      className={className}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      title={title}
      data-testid={title}
    >
      {isActive ? (
        <SelectedPath
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9 14.2669L3.74671 17L4.75 11.2111L0.5 7.11146L6.37336 6.26687L9 1L11.6266 6.26687L17.5 7.11146L13.25 11.2111L14.2533 17L9 14.2669Z"
        />
      ) : (
        <UnselectedPath d="M9.23077 13.8233L9 13.7033L8.76923 13.8233L4.41182 16.0903L5.24266 11.2965L5.28793 11.0353L5.09713 10.8513L1.58248 7.46094L6.44452 6.76178L6.70387 6.72449L6.8208 6.49002L9 2.12035L11.1792 6.49002L11.2961 6.72449L11.5555 6.76178L16.4175 7.46094L12.9029 10.8513L12.7121 11.0353L12.7573 11.2965L13.5882 16.0903L9.23077 13.8233Z" />
      )}
    </SvgElement>
  );
};

export default StarSvgAsComponent;
